/**
 * Support contact form — "I'm exploring / I'm a customer" segmented toggle.
 * Switching to "customer" reveals the .cust-only fields (license key).
 */
export function initSupportForm() {
	const form = document.querySelector('.ticket');
	const seg = form ? form.querySelector('.seg') : null;
	if (!form || !seg) return;

	seg.addEventListener('click', (e) => {
		const button = e.target.closest('button[data-mode]');
		if (!button) return;
		seg.querySelectorAll('button').forEach((b) => b.classList.remove('on'));
		button.classList.add('on');
		form.classList.toggle('is-customer', button.dataset.mode === 'customer');
	});
}
